import React from 'react';

const ContentSection = () => {
    return (
        <>
            <section className="about__area pb-100">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="about__wrapper">
                                <div className="innerBox">
                                    <img src="assets/img/about-icon1.png" alt="Dsider" />
                                    <div className="">
                                        <h3>Industry and Data Science Experts</h3>
                                        <p>Our team brings a combined experience of 100 years in industry and data science, ensuring insights are interpretable, driven by expertise and deep understanding of complex problems.</p>
                                    </div>
                                </div>
                                <div className="innerBox bg2">
                                    <img src="assets/img/about-icon2.png" alt="Dsider" />
                                    <div className="">
                                        <h3>User- Friendly Platform</h3>
                                        <p>Bid farewell to overwhelming spreadsheets. Dsider provides a streamlined platform that simplifies data management and analysis, making it easy to access and analyze crucial metrics efficiently.</p>
                                    </div>
                                </div>
                                <div className="innerBox bg3">
                                    <img src="assets/img/about-icon3.png" alt="Dsider" />
                                    <div className="">
                                        <h3>Templated Analysis with Language Interpretation and Comprehensive Reports </h3>
                                        <p>Dsider offers templated analysis powered by language interpretation, delivering detailed reports for energy and product planning, economic analysis, and emissions reporting. Our insights ensure better decision-making and improved operational efficiency.</p>
                                    </div>
                                </div>
                                <div className="innerBox bg4">
                                    <img src="assets/img/about-icon4.png" alt="Dsider" />
                                    <div className="">
                                        <h3>Optimization and Scaling</h3>
                                        <p>Maximize your technology investment. Dsider helps optimize and scale your solutions to achieve the best economic outcomes, ensure long-term value, and conduct business model analysis to drive sustainable growth.</p>
                                    </div>
                                </div>
                                <div className="innerBox bg5">
                                    <img src="assets/img/about-icon5.png" alt="Dsider" />
                                    <div className="">
                                        <h3>End-to-End Analysis</h3>
                                        <p>From Front-End Engineering Design (FEED) to Final Investment Decision (FID) and business development, our analysis saves you time and reduces costs by providing a holistic approach.</p>
                                    </div>
                                </div>
                                <div className="innerBox bg6">
                                    <img src="assets/img/about-icon6.png" alt="Dsider" />
                                    <div className="">
                                        <h3>Life Cycle Analysis</h3>
                                        <p>Life cycle analysis with auditable carbon emissions and economics, covering everything from strategy formulation to operational execution, helping you ensure long-term sustainability and efficiency.</p>
                                    </div>
                                </div>
                                <div className="innerBox bg7">
                                    <img src="assets/img/about-icon7.png" alt="Dsider" />
                                    <div className="">
                                        <h3>Ongoing Expert Assistance</h3>
                                        <p>Our commitment doesn't stop at implementation. We provide continuous support from our expert team to ensure your success at every stage.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="section__title pt-50">
                                <span>Choose Dsider to unlock the full potential of your projects and drive impactful, data-driven results.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContentSection;